import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { authApi } from '../../api/authApi';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setError('');
    setSuccess(false);
    if (!email.trim()) {
      setError('Inserisci la tua email');
      return;
    }
    setLoading(true);
    try {
      await authApi.forgotPassword(email.trim());
      setSuccess(true);
    } catch (err: unknown) {
      const msg = err instanceof Error ? err.message : 'Richiesta fallita. Riprova.';
      setError(msg);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-card-header">
          <div className="auth-card-logo">
            <i className="bi bi-key-fill" />
          </div>
          <h1 className="auth-card-title">Recupera password</h1>
          <p className="auth-card-subtitle">
            Inserisci l&apos;email dell&apos;account. Ti invieremo un link per reimpostare la password (valido 1 ora).
          </p>
        </div>

        <div className="auth-card-body">
          {success ? (
            <div className="alert alert-success auth-alert">
              <i className="bi bi-check-circle me-2" />
              Controlla la tua casella email. Se l&apos;account esiste, riceverai un link per reimpostare la password.
            </div>
          ) : (
            <form onSubmit={submit} className="auth-form">
              <div className="mb-3">
                <label htmlFor="forgot-email" className="form-label">Email</label>
                <input
                  id="forgot-email"
                  type="email"
                  className="form-control"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="es. mario@azienda.it"
                  autoComplete="email"
                  autoFocus
                />
              </div>
              {error && (
                <div className="alert alert-danger auth-alert mb-3" role="alert">
                  <i className="bi bi-exclamation-circle me-2" />
                  {error}
                </div>
              )}
              <button
                className="btn auth-btn-primary mb-0"
                type="submit"
                disabled={loading}
              >
                {loading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" />
                    Invio in corso...
                  </>
                ) : (
                  <>
                    <i className="bi bi-send me-2" />
                    Invia link recupero
                  </>
                )}
              </button>
            </form>
          )}

          <div className="auth-links text-center">
            <p className="mb-0">
              <Link to="/login">Torna al login</Link>
              {' · '}
              <Link to="/register">Registrati</Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
